import { SECTION_TYPE } from "dt-components/lib/es/components/molecules/landingPage/enum";
import { IDataSection } from "src/types";

export const getScriptsFromPB = (data: IDataSection[]) => {
  const scripts: Element[] = [];
  data.forEach((item) => {
    if (item.type === SECTION_TYPE.CUSTOM_HTML && item.metaData[0]) {
      if (item.metaData[0].links?.length) {
        item.metaData[0].links.map((link: string) => {
          if (link !== "") {
            // @ts-ignore
            scripts.push(<script async src={link} />);
          }
        });
      } else if (item.metaData[0].link) {
        // @ts-ignore
        scripts.push(<script async src={item.metaData[0].link} />);
      }
    }
  });

  return scripts;
};
